/**
 * @module events/types/error
 */

/**
 * @type {string}
 */
export default 'error'
